import React from 'react';
import { RegularButton as Button, Skeleton } from 'fronton-react';
import { ArrowRightIcon } from '@fronton/icons-react';
import { useBasketState, useBasketUpdate } from 'pages/common/store/basket';
import { goToCartButtonClass } from './styles';

type TProps = {
  onClickBasket: () => void;
  onClickToBasket: () => void;
  addToCartIsSuccessful: boolean;
  formName?: string;
  cartTitle?: string;
  toCartTitle?: string;
};

export const Cart: React.FC<TProps> = ({
  onClickBasket,
  onClickToBasket,
  addToCartIsSuccessful,
  formName,
  cartTitle = 'Корзина',
  toCartTitle = 'В корзину',
}) => {
  const { isBasketLoading, loadBasket, updateBasket } = useBasketState();
  useBasketUpdate(loadBasket, updateBasket);

  return (
    <>
      {addToCartIsSuccessful ? (
        <Button
          data-testid="calculation_go_to_cart_button"
          className={goToCartButtonClass}
          size="l"
          variant="primary"
          onClick={onClickBasket}
          withExtraClickZone
          iconRight={<ArrowRightIcon type="outline" size="l" color="text-invert" />}>
          {cartTitle}
        </Button>
      ) : (
        <Skeleton variant="control" showLoading={isBasketLoading} width="100%">
          <Button
            size="l"
            variant="primary"
            label={toCartTitle}
            {...(formName && { type: 'submit', form: formName })}
            onClick={onClickToBasket}
            wide>
            {toCartTitle}
          </Button>
        </Skeleton>
      )}
    </>
  );
};
